import { Select, Table } from '@approvalmax/ui/src/components';
import { memo } from 'react';
import { useWatch } from 'react-hook-form';

import { useTaxCodes } from './TaxCodeCell.hooks';
import { messages } from './TaxCodeCell.messages';
import { TaxCodeCellProps } from './TaxCodeCell.types';

export const TaxCodeCell = memo<TaxCodeCellProps>((props) => {
    const { name, control, subsidiaryIdName, ...otherProps } = props;

    const subsidiaryId = useWatch({ control, name: subsidiaryIdName });
    const { isFetching, setQuery, items } = useTaxCodes(subsidiaryId);

    return (
        <Table.FormCell name={name} {...otherProps}>
            {({ name, ref }) => {
                return (
                    <Select
                        name={name}
                        activatorRef={ref}
                        placeholder={messages.selectPlaceholder}
                        preventSearch
                        autocomplete
                        items={items}
                        onInputChange={setQuery}
                        progress={isFetching}
                        bordered={false}
                        size='small'
                    />
                );
            }}
        </Table.FormCell>
    );
});

TaxCodeCell.displayName = 'TaxCodeCell';
